import React from 'react'
import UserCard from './UserCard.jsx'

const Andy = () =>
  <UserCard
    name="Andy"
    title="Technical Manager"
    dyk="In his younger days Andy used to model for a photo story magazine!"
  >
    <p>
      After school Andy gained a ND in art and design followed by a HND in
      photography. He then spent over 25 years as a technician in Nikon's NPS
      department, and more recently as a CPS engineer at Canon. Andy downed
      tools in 2023 and brings a wealth of technical experience to team LFH,
      where he manages our ever-growing arsenal of kit. Away from work, he
      loves family time and sport - tennis being his first choice. Andy often
      needs reminding he is very far from being in his twenties!
    </p>
  </UserCard>

export default Andy